var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c("page-header", {
          attrs: { "has-return": "", page: _vm.pageConfig },
          on: {
            onReturn: function($event) {
              return _vm.$router.go(-1)
            }
          }
        }),
        _c("section-title", {
          attrs: {
            "container-class": "tag-badge-main-info m-0 mb-3",
            content: "Detalle de Alertas",
            icon: "fas fa-file-alt"
          }
        }),
        _vm.result.data === 0 ? _c("custom-result-not-found") : _vm._e(),
        _vm.result.data.length !== 0
          ? _c(
              "div",
              [
                _vm._l(_vm.result.data, function(item) {
                  return _c(
                    "custom-callout",
                    {
                      key: item.$key,
                      staticClass: "mt-4 mb-4",
                      attrs: { "has-toggle": false }
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        !item.billingNumber
                          ? _c("div", { staticClass: "col-6 col-md-2" }, [
                              _c("span", { staticClass: "body-2 text-gray" }, [
                                _vm._v("Número SIE:")
                              ]),
                              _c(
                                "p",
                                { staticClass: "body-1 font-weight-normal" },
                                [_vm._v(" " + _vm._s(item.studentSieId) + " ")]
                              )
                            ])
                          : _vm._e(),
                        !item.billingNumber
                          ? _c("div", { staticClass: "col-6 col-md-3" }, [
                              _c("span", { staticClass: "body-2 text-gray" }, [
                                _vm._v(" Nombre Estudiante: "),
                                _c("br")
                              ]),
                              _c(
                                "span",
                                { staticClass: "body-1 font-weight-normal" },
                                [_vm._v(_vm._s(item.fullName))]
                              )
                            ])
                          : _vm._e(),
                        item.billingNumber
                          ? _c("div", { staticClass: "col-6 col-md-2" }, [
                              _c("span", { staticClass: "body-2 text-gray" }, [
                                _vm._v("Número de Factura:")
                              ]),
                              _c(
                                "p",
                                { staticClass: "body-1 font-weight-normal" },
                                [_vm._v(" " + _vm._s(item.billingNumber) + " ")]
                              )
                            ])
                          : _vm._e(),
                        item.billingNumber
                          ? _c("div", { staticClass: "col-6 col-md-2" }, [
                              _c("span", { staticClass: "body-2 text-gray" }, [
                                _vm._v("Proveedor:")
                              ]),
                              _c(
                                "p",
                                { staticClass: "body-1 font-weight-normal" },
                                [_vm._v(" " + _vm._s(item.companyName) + " ")]
                              )
                            ])
                          : _vm._e(),
                        _c("div", { staticClass: "col-6 col-md-2" }, [
                          _c("span", { staticClass: "body-2 text-gray" }, [
                            _vm._v(" Tipo Alerta: "),
                            _c("br")
                          ]),
                          _c(
                            "span",
                            { staticClass: "body-1 font-weight-normal" },
                            [_vm._v(" " + _vm._s(item.alertType) + " ")]
                          )
                        ]),
                        _c("div", { staticClass: "col-6 col-md-2" }, [
                          _c("span", { staticClass: "body-2 text-gray" }, [
                            _vm._v(" Sub Tipo Alerta: "),
                            _c("br")
                          ]),
                          _c(
                            "span",
                            { staticClass: "body-1 font-weight-normal" },
                            [_vm._v(_vm._s(item.subType))]
                          )
                        ]),
                        _c("div", { staticClass: "col-6 col-md-2" }, [
                          _c("span", { staticClass: "body-2 text-gray" }, [
                            _vm._v(" Fecha: "),
                            _c("br")
                          ]),
                          item.billingNumber
                            ? _c(
                                "span",
                                {
                                  attrs: { lass: "body-1 font-weight-normal" }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("date")(item.statusChangedDate)
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _c("div", { staticClass: "col-6 col-md-2" }, [
                          _c("span", { staticClass: "body-2 text-gray" }, [
                            _vm._v(" Record Seleccionado: "),
                            _c("br")
                          ]),
                          _c(
                            "span",
                            { staticClass: "body-1 font-weight-normal" },
                            [_vm._v(" " + _vm._s(item.recordKey) + " ")]
                          )
                        ])
                      ]),
                      _c("div", { staticClass: "row border-top pt-2 mr-2" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c("span", { staticClass: "body-2 text-gray" }, [
                            _vm._v(" Alerta: "),
                            _c("br")
                          ]),
                          _c(
                            "span",
                            { staticClass: "body-1 font-weight-normal" },
                            [_vm._v(" " + _vm._s(item.alertDescription) + " ")]
                          )
                        ])
                      ]),
                      _c("br"),
                      item.message
                        ? _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-6 col-md-9" }, [
                              _c("span", { staticClass: "body-2 text-gray" }, [
                                _vm._v(" Mensaje: ")
                              ]),
                              _c(
                                "span",
                                { staticClass: "body-1 font-weight-normal" },
                                [
                                  _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(item.message)
                                    }
                                  })
                                ]
                              )
                            ])
                          ])
                        : _vm._e()
                    ]
                  )
                }),
                _vm.showPagination
                  ? _c("pagination", {
                      attrs: {
                        data: _vm.result.pagination,
                        "page-size": _vm.pageSize,
                        "show-text": true
                      },
                      on: { "pagination-go-page": _vm.onChangePageHandler }
                    })
                  : _vm._e()
              ],
              2
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }